export const videos = [
  {
    id: 1,
    title: "星海远征",
    type: "电影",
    typeKey: "movie",
    region: "中国大陆",
    year: 2025,
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20of%20a%20lone%20astronaut%20standing%20before%20a%20colossal%20glowing%20nebula%20and%20distant%20starship%2C%20dramatic%20rim%20lighting%2C%20deep%20space%20atmosphere%2C%20high%20detail%2C%20vertical%20poster%20composition%2C%20dark%20tonal%20background&width=400&height=600&seq=v91-cover-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20space%20scene%20with%20a%20giant%20planet%20horizon%2C%20glowing%20orange%20nebula%20clouds%20and%20silhouetted%20spaceship%20flying%20through%20star%20field%2C%20dramatic%20light%2C%20dark%20background%20with%20warm%20accent%20glow%2C%20high%20detail%20movie%20key%20art&width=1920&height=800&seq=v91-hero-01&orientation=landscape",
    tags: ["科幻", "冒险"],
    cast: "林航 / 苏芸 / 陆沉",
    director: "陈望北",
    synopsis:
      "一支深空探测队在返航途中遭遇未知引力场，飞船被迫偏离航线。队长林航带领仅存的队员穿越陌生的星海，在有限的能源与时间里寻找回家的坐标。影片以冷峻的宇宙视角，讲述人类在浩瀚孤独中的勇气与牵挂。",
    views: 982300,
    updatedAt: "2025-09-28",
    episodes: [],
    featured: true,
  },
  {
    id: 2,
    title: "迷雾追凶",
    type: "电影",
    typeKey: "movie",
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    cover: "https://readdy.ai/api/search-image?query=Moody%20suspense%20thriller%20movie%20poster%20with%20a%20detective%20silhouette%20walking%20under%20a%20lonely%20streetlamp%20in%20thick%20fog%2C%20rain%20slicked%20pavement%20reflection%2C%20film%20noir%20lighting%2C%20dark%20muted%20tones%2C%20vertical%20poster%20composition%2C%20high%20detail&width=400&height=600&seq=v91-cover-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Rainy%20night%20city%20street%20in%20heavy%20fog%20with%20glowing%20street%20lamps%20and%20wet%20asphalt%20reflections%2C%20cinematic%20noir%20atmosphere%2C%20deep%20dark%20tones%20with%20warm%20lamp%20highlights%2C%20moody%20film%20scene%2C%20high%20detail&width=1920&height=800&seq=v91-hero-02&orientation=landscape",
    tags: ["悬疑", "犯罪"],
    cast: "周牧 / 何清岚 / 方锐",
    director: "李尚远",
    synopsis:
      "连续失踪案在城市夜色中悄然发生，刑警周牧循着一条模糊的线索追入层层迷雾。当真相逐渐浮现，他发现案件与十年前那桩悬案有着惊人联系。节奏紧凑，反转不断。",
    views: 765100,
    updatedAt: "2025-08-15",
    episodes: [],
    featured: true,
  },
  {
    id: 3,
    title: "长安夜行",
    type: "电视剧",
    typeKey: "tv",
    region: "中国大陆",
    year: 2025,
    rating: 9.1,
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20era%20TV%20drama%20poster%20with%20a%20lone%20figure%20in%20flowing%20robes%20holding%20a%20lantern%20on%20a%20snowy%20palace%20rooftop%20at%20night%2C%20misty%20lanterns%2C%20elegant%20classical%20aesthetic%2C%20vertical%20poster%20composition%2C%20high%20detail&width=400&height=600&seq=v91-cover-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20capital%20city%20at%20night%20with%20glowing%20lanterns%2C%20snow%20falling%20over%20elegant%20palace%20roofs%20and%20long%20street%2C%20warm%20amber%20lantern%20light%20against%20deep%20dark%20sky%2C%20cinematic%20historical%20atmosphere%2C%20high%20detail&width=1920&height=800&seq=v91-hero-03&orientation=landscape",
    tags: ["古装", "悬疑", "权谋"],
    cast: "沈砚 / 苏挽月 / 裴决",
    director: "顾长亭",
    synopsis:
      "大唐上元夜，一桩离奇命案惊动长安。大理寺少卿沈砚奉命彻查，却发现每一步都踩在权谋的刀尖上。灯影摇曳之下，正义与私情、忠诚与背叛交织成一张大网。全剧共 36 集，服化道考究，画面精致。",
    views: 1526800,
    updatedAt: "2025-10-06",
    episodes: [
      { id: 1, title: "第 1 集 · 上元惊变", duration: "45:12" },
      { id: 2, title: "第 2 集 · 灯下故人", duration: "44:38" },
      { id: 3, title: "第 3 集 · 无头案卷", duration: "46:05" },
      { id: 4, title: "第 4 集 · 暗巷杀机", duration: "45:20" },
      { id: 5, title: "第 5 集 · 金吾卫令", duration: "44:59" },
      { id: 6, title: "第 6 集 · 雪夜密谈", duration: "45:44" },
    ],
    featured: true,
  },
  {
    id: 4,
    title: "都市之光",
    type: "电视剧",
    typeKey: "tv",
    region: "中国大陆",
    year: 2024,
    rating: 8.0,
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20workplace%20drama%20poster%20with%20a%20confident%20young%20professional%20standing%20against%20a%20glass%20skyscraper%20facade%20at%20dusk%2C%20warm%20city%20bokeh%20lights%2C%20clean%20contemporary%20style%2C%20vertical%20poster%20composition%2C%20high%20detail&width=400&height=600&seq=v91-cover-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Modern%20metropolitan%20skyline%20at%20dusk%20with%20glowing%20office%20windows%20and%20warm%20city%20lights%2C%20cinematic%20wide%20shot%20of%20a%20bustling%20business%20district%2C%20dark%20sky%20with%20amber%20highlights%2C%20high%20detail&width=1920&height=800&seq=v91-hero-04&orientation=landscape",
    tags: ["都市", "职场", "成长"],
    cast: "许知远 / 罗玟 / 唐糖",
    director: "程亦",
    synopsis:
      "初入职场的许知远在一家新锐公司里跌跌撞撞，从被质疑到独当一面。剧集用细腻的镜头记录年轻人的奋斗与迷茫，也记录他们如何在钢筋森林里守住自己的那束光。全剧共 40 集。",
    views: 892400,
    updatedAt: "2025-07-22",
    episodes: [
      { id: 1, title: "第 1 集 · 入职第一天", duration: "42:10" },
      { id: 2, title: "第 2 集 · 意外的项目", duration: "43:01" },
      { id: 3, title: "第 3 集 · 深夜加班", duration: "41:55" },
      { id: 4, title: "第 4 集 · 竞标风波", duration: "42:47" },
    ],
  },
  {
    id: 5,
    title: "欢乐大闯关",
    type: "综艺",
    typeKey: "variety",
    region: "中国大陆",
    year: 2025,
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20Chinese%20reality%20game%20show%20poster%20with%20joyful%20contestants%20celebrating%20on%20a%20colorful%20obstacle%20course%2C%20confetti%20and%20stage%20lights%2C%20energetic%20playful%20style%2C%20vertical%20poster%20composition%2C%20high%20detail&width=400&height=600&seq=v91-cover-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Bright%20colorful%20television%20game%20show%20stage%20with%20glowing%20lights%2C%20obstacle%20course%20and%20cheering%20audience%2C%20energetic%20festive%20atmosphere%2C%20warm%20orange%20stage%20lighting%20against%20dark%20hall%2C%20high%20detail&width=1920&height=800&seq=v91-hero-05&orientation=landscape",
    tags: ["真人秀", "喜剧", "竞技"],
    cast: "天天家族 / 主持天团",
    director: "综艺中心",
    synopsis:
      "十二位嘉宾在花样百出的关卡中组团闯关，笑料与意外齐飞。每期都有全新的主题与挑战，欢乐不断，适合全家一起观看。",
    views: 1130500,
    updatedAt: "2025-10-01",
    episodes: [
      { id: 1, title: "第 1 期 · 极限闯关", duration: "78:20" },
      { id: 2, title: "第 2 期 · 水上大战", duration: "80:05" },
      { id: 3, title: "第 3 期 · 城市寻宝", duration: "76:48" },
    ],
  },
  {
    id: 6,
    title: "星际迷航：归途",
    type: "电影",
    typeKey: "movie",
    region: "美国",
    year: 2024,
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Grand%20space%20opera%20movie%20poster%20with%20a%20massive%20starship%20emerging%20from%20a%20vivid%20cosmic%20vortex%2C%20glowing%20engine%20trails%20and%20distant%20galaxies%2C%20epic%20dramatic%20lighting%2C%20dark%20background%20with%20orange%20glow%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Sweeping%20wide%20shot%20of%20a%20fleet%20of%20starships%20traveling%20through%20a%20glowing%20orange%20nebula%20toward%20a%20bright%20distant%20star%2C%20epic%20science%20fiction%20space%20landscape%2C%20dramatic%20lighting%2C%20dark%20cosmic%20background%2C%20high%20detail&width=1920&height=800&seq=v91-hero-06&orientation=landscape",
    tags: ["科幻", "太空", "冒险"],
    cast: "Ellis Grant / Mara Voss / Dee Sun",
    director: "Noah Bennett",
    synopsis:
      "深空舰队的旗舰在一次跃迁后与母星失去联系，船员们必须穿越未知星域，寻找那条通往家园的航道。宏大的世界观与细腻的人物群像，让这部作品成为年度科幻话题之作。",
    views: 1320900,
    updatedAt: "2025-06-30",
    episodes: [],
    featured: true,
  },
  {
    id: 7,
    title: "暗夜骑士：重生",
    type: "电影",
    typeKey: "movie",
    region: "美国",
    year: 2023,
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Dark%20superhero%20action%20movie%20poster%20with%20a%20caped%20figure%20standing%20on%20a%20rainy%20city%20rooftop%20overlooking%20neon%20skyline%2C%20dramatic%20backlight%2C%20moody%20dark%20tones%20with%20amber%20highlights%2C%20vertical%20poster%20composition&width=400&height=600&seq=v91-cover-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dark%20gritty%20city%20skyline%20at%20night%20seen%20from%20a%20rooftop%20with%20storm%20clouds%20and%20distant%20lightning%2C%20cinematic%20moody%20atmosphere%2C%20deep%20shadows%20with%20warm%20window%20lights%2C%20high%20detail%20action%20film%20key%20art&width=1920&height=800&seq=v91-hero-07&orientation=landscape",
    tags: ["动作", "英雄"],
    cast: "Marcus Hale / Ivy Chan",
    director: "Ryan Cole",
    synopsis:
      "在一次惨烈的失败之后，昔日守护城市的英雄销声匿迹。当新的威胁笼罩夜色，他必须直面内心的裂痕，重新披上斗篷。场面震撼，情感厚重。",
    views: 1044700,
    updatedAt: "2025-05-18",
    episodes: [],
  },
  {
    id: 8,
    title: "首尔恋歌",
    type: "电视剧",
    typeKey: "tv",
    region: "韩国",
    year: 2024,
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20poster%20with%20a%20young%20couple%20under%20falling%20autumn%20leaves%20on%20a%20quiet%20city%20street%2C%20soft%20golden%20hour%20light%2C%20warm%20tender%20mood%2C%20vertical%20poster%20composition%2C%20high%20detail&width=400&height=600&seq=v91-cover-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Sweeping%20autumn%20city%20park%20path%20covered%20in%20golden%20leaves%20with%20warm%20sunset%20light%20filtering%20through%20trees%2C%20romantic%20cinematic%20atmosphere%2C%20soft%20amber%20tones%20against%20dark%20shadows%2C%20high%20detail&width=1920&height=800&seq=v91-hero-08&orientation=landscape",
    tags: ["爱情", "都市", "治愈"],
    cast: "韩智媛 / 李瑞俊",
    director: "金道允",
    synopsis:
      "一位料理老师与一位电台主播在首尔的秋天相遇，两个受过伤的人在慢节奏的城市生活里彼此治愈。细腻的对白与温暖的画面，让人相信温柔的力量。",
    views: 1188600,
    updatedAt: "2025-09-12",
    episodes: [
      { id: 1, title: "第 1 集 · 秋日初遇", duration: "62:14" },
      { id: 2, title: "第 2 集 · 深夜电台", duration: "61:40" },
      { id: 3, title: "第 3 集 · 一场小雨", duration: "63:02" },
      { id: 4, title: "第 4 集 · 心事配方", duration: "62:35" },
    ],
  },
  {
    id: 9,
    title: "东京料理人",
    type: "电视剧",
    typeKey: "tv",
    region: "日本",
    year: 2023,
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Japanese%20food%20drama%20poster%20with%20a%20chef%20carefully%20plating%20a%20delicate%20dish%20in%20a%20small%20warm%20restaurant%2C%20steam%20rising%20under%20soft%20lamp%20light%2C%20cozy%20intimate%20mood%2C%20vertical%20poster%20composition%2C%20high%20detail&width=400&height=600&seq=v91-cover-09&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cozy%20traditional%20Japanese%20restaurant%20counter%20at%20night%20with%20warm%20lantern%20light%2C%20steaming%20bowls%20and%20fresh%20ingredients%2C%20intimate%20cinematic%20atmosphere%2C%20dark%20wood%20tones%20with%20amber%20glow%2C%20high%20detail&width=1920&height=800&seq=v91-hero-09&orientation=landscape",
    tags: ["美食", "治愈", "日常"],
    cast: "佐藤健一 / 小林堇",
    director: "山田凉",
    synopsis:
      "一家藏在巷子深处的小店，老板用一道道看似寻常的家常菜，温暖着每一位深夜来访的客人。食物与人情交织，是疲惫生活里最柔软的慰藉。",
    views: 976200,
    updatedAt: "2025-04-09",
    episodes: [
      { id: 1, title: "第 1 集 · 一碗热汤", duration: "48:10" },
      { id: 2, title: "第 2 集 · 深夜来客", duration: "47:52" },
      { id: 3, title: "第 3 集 · 母亲的味道", duration: "48:40" },
    ],
  },
  {
    id: 10,
    title: "笑对人生",
    type: "综艺",
    typeKey: "variety",
    region: "中国大陆",
    year: 2024,
    rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=Standup%20comedy%20show%20poster%20with%20a%20spotlit%20microphone%20on%20a%20stage%20and%20warm%20spotlight%20beams%2C%20audience%20silhouettes%2C%20playful%20bold%20style%2C%20dark%20background%20with%20orange%20glow%2C%20vertical%20poster%20composition&width=400&height=600&seq=v91-cover-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Intimate%20comedy%20club%20stage%20with%20a%20single%20warm%20spotlight%20and%20microphone%20stand%2C%20seated%20audience%20silhouettes%2C%20moody%20dark%20atmosphere%20with%20amber%20lighting%2C%20high%20detail&width=1920&height=800&seq=v91-hero-10&orientation=landscape",
    tags: ["脱口秀", "喜剧"],
    cast: "脱口秀新星团",
    director: "综艺中心",
    synopsis:
      "一群热爱表达的年轻人站在聚光灯下，用犀利的观察与自嘲讲述生活里的酸甜苦辣。笑着笑着，你会发现自己也被治愈了。",
    views: 701300,
    updatedAt: "2025-03-27",
    episodes: [
      { id: 1, title: "第 1 期 · 上班那些事", duration: "65:00" },
      { id: 2, title: "第 2 期 · 我的家人", duration: "66:22" },
      { id: 3, title: "第 3 期 · 成长的烦恼", duration: "64:18" },
    ],
  },
  {
    id: 11,
    title: "王朝密码",
    type: "电视剧",
    typeKey: "tv",
    region: "英国",
    year: 2025,
    rating: 9.0,
    cover: "https://readdy.ai/api/search-image?query=Historical%20epic%20drama%20poster%20with%20a%20regal%20figure%20in%20dark%20period%20costume%20in%20a%20candlelit%20stone%20hall%2C%20crown%20and%20old%20documents%20on%20a%20table%2C%20dramatic%20chiaroscuro%20lighting%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-11&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Grand%20candlelit%20medieval%20stone%20hall%20with%20tall%20arched%20windows%20and%20burning%20torches%2C%20dramatic%20chiaroscuro%20atmosphere%2C%20dark%20background%20with%20warm%20golden%20light%2C%20cinematic%20historical%20epic%2C%20high%20detail&width=1920&height=800&seq=v91-hero-11&orientation=landscape",
    tags: ["历史", "剧情", "权谋"],
    cast: "Edmund Hale / Clara Vane",
    director: "Oliver Stonefield",
    synopsis:
      "一个古老王朝的兴衰，被一册遗失的密档重新揭开。剧集以史诗般的笔触，描绘权力、信仰与人性的博弈，服化道与摄影质感俱佳。",
    views: 1102400,
    updatedAt: "2025-09-19",
    episodes: [
      { id: 1, title: "第 1 集 · 加冕之前", duration: "58:30" },
      { id: 2, title: "第 2 集 · 密档失窃", duration: "57:44" },
      { id: 3, title: "第 3 集 · 王座阴影", duration: "59:02" },
    ],
  },
  {
    id: 12,
    title: "极速飞驰",
    type: "电影",
    typeKey: "movie",
    region: "中国大陆",
    year: 2024,
    rating: 7.9,
    cover: "https://readdy.ai/api/search-image?query=High%20octane%20racing%20movie%20poster%20with%20a%20sleek%20race%20car%20drifting%20with%20glowing%20headlights%20and%20sparks%20on%20a%20night%20track%2C%20motion%20blur%20speed%20lines%2C%20dark%20background%20with%20orange%20glow%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-12&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Racing%20cars%20speeding%20through%20a%20night%20circuit%20with%20glowing%20headlights%20and%20motion%20blur%20light%20trails%2C%20dramatic%20cinematic%20atmosphere%2C%20dark%20track%20with%20warm%20orange%20highlights%2C%20high%20detail&width=1920&height=800&seq=v91-hero-12&orientation=landscape",
    tags: ["赛车", "动作", "热血"],
    cast: "韩野 / 江澄",
    director: "徐驰",
    synopsis:
      "退役车手韩野为了兄弟的一句话重返赛道，在速度与规则之间寻找属于自己的答案。引擎轰鸣，热血沸腾。",
    views: 812600,
    updatedAt: "2025-08-02",
    episodes: [],
  },
  {
    id: 13,
    title: "江湖笑谈录",
    type: "电视剧",
    typeKey: "tv",
    region: "中国大陆",
    year: 2023,
    rating: 8.1,
    cover: "https://readdy.ai/api/search-image?query=Lighthearted%20Chinese%20wuxia%20comedy%20series%20poster%20with%20a%20young%20swordsman%20grinning%20in%20colorful%20robes%20on%20a%20misty%20mountaintop%2C%20playful%20elegant%20style%2C%20warm%20tones%20against%20dark%20background%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-13&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Misty%20mountain%20peaks%20at%20dawn%20with%20an%20ancient%20Chinese%20pavilion%20perched%20on%20a%20cliff%2C%20soft%20drifting%20fog%20and%20warm%20sunrise%20light%2C%20ethereal%20wuxia%20atmosphere%2C%20dark%20valley%20tones%2C%20high%20detail&width=1920&height=800&seq=v91-hero-13&orientation=landscape",
    tags: ["武侠", "喜剧", "古装"],
    cast: "白小七 / 阿蛮 / 老周",
    director: "桑落",
    synopsis:
      "一个不成器的小门派，一群不靠谱的江湖人，误打误撞卷入了一场又一场啼笑皆非的纷争。笑料之外，也有令人动容的侠义。",
    views: 654800,
    updatedAt: "2025-02-14",
    episodes: [
      { id: 1, title: "第 1 集 · 下山", duration: "43:20" },
      { id: 2, title: "第 2 集 · 客栈疑云", duration: "42:58" },
      { id: 3, title: "第 3 集 · 论剑大会", duration: "44:11" },
    ],
  },
  {
    id: 14,
    title: "深海奇缘",
    type: "电影",
    typeKey: "movie",
    region: "美国",
    year: 2025,
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20movie%20poster%20of%20a%20diver%20descending%20into%20a%20glowing%20deep%20ocean%20trench%20surrounded%20by%20luminous%20creatures%2C%20bioluminescent%20light%2C%20dark%20underwater%20atmosphere%20with%20warm%20glow%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-14&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ethereal%20deep%20ocean%20landscape%20with%20glowing%20jellyfish%2C%20coral%20formations%20and%20shafts%20of%20light%20penetrating%20dark%20water%2C%20cinematic%20underwater%20atmosphere%2C%20warm%20accent%20glow%20in%20dark%20blue%2C%20high%20detail&width=1920&height=800&seq=v91-hero-14&orientation=landscape",
    tags: ["冒险", "奇幻", "海洋"],
    cast: "Nora Reed / Kai Brooks",
    director: "Elena Marsh",
    synopsis:
      "海洋学家在深海探测中发现了一个从未被记录的世界，那里有发光的生命，也有被时光掩埋的秘密。一次关于探索与敬畏的奇幻之旅。",
    views: 1233100,
    updatedAt: "2025-10-08",
    episodes: [],
  },
  {
    id: 15,
    title: "唱响未来",
    type: "综艺",
    typeKey: "variety",
    region: "中国大陆",
    year: 2025,
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Music%20talent%20show%20poster%20with%20a%20singer%20silhouetted%20against%20glowing%20stage%20lights%20and%20confetti%2C%20dynamic%20energetic%20style%2C%20dark%20background%20with%20warm%20orange%20and%20gold%20beams%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-15&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20beam%20lights%20and%20a%20crowd%20of%20glowing%20phone%20lights%2C%20energetic%20live%20music%20atmosphere%2C%20dark%20arena%20with%20warm%20orange%20and%20gold%20stage%20lighting%2C%20high%20detail&width=1920&height=800&seq=v91-hero-15&orientation=landscape",
    tags: ["音乐", "选秀", "励志"],
    cast: "新生代歌手团",
    director: "综艺中心",
    synopsis:
      "来自各地的年轻歌手登上同一个舞台，用声音讲述自己的故事。导师点评、舞台竞演，见证梦想一点点绽放。",
    views: 948700,
    updatedAt: "2025-09-30",
    episodes: [
      { id: 1, title: "第 1 期 · 初舞台", duration: "88:00" },
      { id: 2, title: "第 2 期 · 导师合作", duration: "90:12" },
    ],
  },
  {
    id: 16,
    title: "平凡岁月",
    type: "电视剧",
    typeKey: "tv",
    region: "中国大陆",
    year: 2022,
    rating: 9.2,
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20family%20drama%20poster%20showing%20a%20warm%20old%20Chinese%20courtyard%20home%20at%20dusk%20with%20warm%20window%20light%2C%20a%20family%20silhouette%20gathered%20inside%2C%20tender%20sentimental%20mood%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-16&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Nostalgic%20old%20Chinese%20hutong%20neighborhood%20at%20golden%20dusk%20with%20bicycles%2C%20laundry%20lines%20and%20warm%20window%20lights%2C%20sentimental%20cinematic%20atmosphere%2C%20dark%20evening%20tones%20with%20amber%20glow%2C%20high%20detail&width=1920&height=800&seq=v91-hero-16&orientation=landscape",
    tags: ["年代", "家庭", "剧情"],
    cast: "老周一家 / 胡同邻里",
    director: "郝明",
    synopsis:
      "一条老胡同，几户普通人家的四十年。剧集用平实的镜头记录时代的变迁与亲情的坚守，豆瓣高分口碑之作，温暖无数观众。",
    views: 1476200,
    updatedAt: "2025-01-30",
    episodes: [
      { id: 1, title: "第 1 集 · 回到那年", duration: "45:00" },
      { id: 2, title: "第 2 集 · 街坊邻里", duration: "44:32" },
      { id: 3, title: "第 3 集 · 第一台电视", duration: "45:18" },
      { id: 4, title: "第 4 集 · 父子之间", duration: "46:02" },
    ],
  },
  {
    id: 17,
    title: "光影谜城",
    type: "电影",
    typeKey: "movie",
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    cover: "https://readdy.ai/api/search-image?query=Moody%20mystery%20film%20poster%20of%20a%20solitary%20photographer%20holding%20a%20vintage%20camera%20in%20a%20neon%20lit%20old%20city%20alley%20at%20night%2C%20dramatic%20shadow%20play%2C%20dark%20tones%20with%20warm%20orange%20glow%2C%20vertical%20poster%20composition%2C%20high%20detail&width=400&height=600&seq=v91-cover-17&orientation=portrait",
    tags: ["悬疑", "剧情"],
    cast: "方可 / 邱野",
    director: "邓一鸣",
    synopsis:
      "一位老摄影师在一卷旧胶片里发现了被刻意抹去的影像，循着画面中的蛛丝马迹，他逐渐走进一座城市被遗忘的往事。光影之间，真相若隐若现。",
    views: 566200,
    updatedAt: "2025-09-05",
    episodes: [],
  },
  {
    id: 18,
    title: "时光信笺",
    type: "电视剧",
    typeKey: "tv",
    region: "韩国",
    year: 2025,
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20poster%20with%20a%20young%20woman%20reading%20an%20old%20letter%20by%20a%20sunlit%20window%2C%20soft%20warm%20afternoon%20light%2C%20delicate%20tender%20mood%2C%20muted%20warm%20tones%2C%20vertical%20poster%20composition%2C%20high%20detail&width=400&height=600&seq=v91-cover-18&orientation=portrait",
    tags: ["爱情", "奇幻", "治愈"],
    cast: "郑河娜 / 朴叙言",
    director: "李恩星",
    synopsis:
      "一个老旧的邮筒里，总能收到寄往过去的信。两位素未谋面的年轻人在不同时空里互通书信，用文字温暖了彼此最孤独的时光。",
    views: 643900,
    updatedAt: "2025-09-25",
    episodes: [
      { id: 1, title: "第 1 集 · 陌生来信", duration: "60:12" },
      { id: 2, title: "第 2 集 · 回信", duration: "61:05" },
      { id: 3, title: "第 3 集 · 时空交错", duration: "59:48" },
    ],
  },
  {
    id: 19,
    title: "星厨驾到",
    type: "综艺",
    typeKey: "variety",
    region: "中国大陆",
    year: 2025,
    rating: 8.2,
    cover: "https://readdy.ai/api/search-image?query=Energetic%20cooking%20competition%20show%20poster%20with%20chefs%20plating%20colorful%20dishes%20under%20bright%20stage%20lights%2C%20steam%20and%20sparks%20flying%2C%20festive%20warm%20style%2C%20dark%20background%20with%20orange%20glow%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-19&orientation=portrait",
    tags: ["美食", "真人秀", "竞技"],
    cast: "明星厨师团",
    director: "综艺中心",
    synopsis:
      "来自各地的大厨同台竞技，用有限的时间与食材完成一道道惊艳料理。紧张的对决之外，也有讲述食物背后人情故事的温柔时刻。",
    views: 502100,
    updatedAt: "2025-08-28",
    episodes: [
      { id: 1, title: "第 1 期 · 开幕赛", duration: "82:10" },
      { id: 2, title: "第 2 期 · 家宴主题", duration: "80:44" },
    ],
  },
  {
    id: 20,
    title: "极限挑战营",
    type: "综艺",
    typeKey: "variety",
    region: "中国大陆",
    year: 2024,
    rating: 7.8,
    cover: "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20reality%20show%20poster%20with%20a%20team%20of%20contestants%20climbing%20a%20mountain%20ridge%20at%20sunrise%2C%20dramatic%20golden%20light%2C%20triumphant%20energetic%20mood%2C%20dark%20tones%20with%20warm%20highlights%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-20&orientation=portrait",
    tags: ["户外", "竞技", "真人秀"],
    cast: "挑战勇士团",
    director: "综艺中心",
    synopsis:
      "穿越山谷、横渡江河、挑战体能极限，一群嘉宾在自然中完成看似不可能的任务。汗水与欢笑同在，团队情谊在挑战中升温。",
    views: 431600,
    updatedAt: "2024-11-30",
    episodes: [
      { id: 1, title: "第 1 期 · 山野集结", duration: "76:30" },
      { id: 2, title: "第 2 期 · 激流勇进", duration: "78:12" },
    ],
  },
  {
    id: 21,
    title: "山海纪行",
    type: "电影",
    typeKey: "movie",
    region: "中国大陆",
    year: 2023,
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20film%20poster%20of%20a%20young%20traveler%20standing%20before%20a%20mythical%20mountain%20range%20and%20sea%20of%20clouds%2C%20giant%20ancient%20creature%20silhouette%20in%20the%20distance%2C%20warm%20ethereal%20light%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-21&orientation=portrait",
    tags: ["奇幻", "冒险", "古装"],
    cast: "云澈 / 黎昭",
    director: "桑落",
    synopsis:
      "少年云澈为寻找失踪的兄长踏上旅途，穿越传说中的山海异境。沿途遇见的奇兽与仙人，让他逐渐读懂那句古老预言背后的深意。",
    views: 723400,
    updatedAt: "2025-03-16",
    episodes: [],
  },
  {
    id: 22,
    title: "急诊风云",
    type: "电视剧",
    typeKey: "tv",
    region: "美国",
    year: 2024,
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20of%20a%20determined%20doctor%20in%20scrubs%20standing%20in%20a%20bright%20hospital%20corridor%20under%20cool%20emergency%20lights%2C%20tense%20professional%20atmosphere%2C%20muted%20tones%20with%20warm%20accents%2C%20vertical%20poster%2C%20high%20detail&width=400&height=600&seq=v91-cover-22&orientation=portrait",
    tags: ["医疗", "剧情", "职业"],
    cast: "Ethan Cole / Mira Patel",
    director: "Sarah Whitmore",
    synopsis:
      "急诊科的每一天都是与时间的赛跑。一群医护在高压与疲惫中坚守岗位，在生死之间守护着每一个家庭的希望。群像细腻，节奏紧张。",
    views: 617800,
    updatedAt: "2025-07-11",
    episodes: [
      { id: 1, title: "第 1 集 · 交接班", duration: "47:22" },
      { id: 2, title: "第 2 集 · 雨中急救", duration: "48:03" },
      { id: 3, title: "第 3 集 · 长夜", duration: "46:51" },
    ],
  },
];

export const regions = ["全部", "中国大陆", "美国", "韩国", "日本", "英国"];

export const years = ["全部", "2025", "2024", "2023", "2022"];